import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute() {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex h-screen items-center justify-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin brand-text" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
